import React, {useState,useEffect,useRef} from "react";
import { Row, Col,Image } from 'antd';
import {bookcover,getbook} from '../../api/api'
import { useHistory } from 'react-router-dom'
import listbook from '../../api/images/emptybook.png'
import 'react-loading-skeleton/dist/skeleton.css'
import './styles.css';
import Error500 from '../error/500';
import Offline from '../error/offline';
import PageHader from "../../component/pageheader/pageHeader";
import Skeletonbook from '../../component/skeleton/skeletonbook';
import Space from '../../component/dashboard/space';
const Booksbycategory=(props)=> {
    const history = useHistory();
    const [category,setcategory]= useState(props.match.params.category)
    const [books,setBooks]=useState([])
    const [emptyBooks,setEmptyBooks]=useState([{},{},{},{},{},{},{},{}])
    const [isLoading,setIsLoading]=useState(false)
    const [isMoreLoading,setIsMoreLoading]=useState(false)
    const [isHaveMoreData,setIsHaveMoreData]=useState(true)
    const [pagenation,setPagenation]=useState(0)
    const windowWidth = useRef(window.innerWidth);
    const [error, setError] = useState(false)
    const isOnLine=localStorage.getItem('isonline')
   
   
    useEffect(() => {
        window.scrollTo(0, 0)
        setIsLoading(true)
        getBooksList()
     }, [])
    
   
const  getBooksList = async() => {
    console.log("pagenation",pagenation)
      let url=getbook+pagenation;
      console.log("cat",category)
      if(category=="newreleases"){
        setcategory("New Releases")
          url=getbook+pagenation
      }else if(category=="booksbyrating"){
        setcategory("Books By Rating")
          url=getbook+pagenation+"&rating=1"
      }else if(category=="openaccessbooks"){
        setcategory("Open Access Books")
         url=getbook+pagenation+"&access=1"
      }else if(category=="paidbook"){
        setcategory("Paid Book")
        url=getbook+pagenation+"&paid=1"
     }
         var requestOptions = {
          method: 'GET',
          redirect: 'follow'
        };
        
        fetch(url, requestOptions)
          .then(response => response.json())
          .then(result =>{
               setBooks(prevTime=>prevTime.concat(result.data))
               setIsLoading(false)
               setIsMoreLoading(false)
               setPagenation(pagenation+20)
               if(result.data.length < 20){
                setIsHaveMoreData(false)

               }
          })
          .catch(error =>{ 
            setIsLoading(false)
            setIsMoreLoading(false)
            setError(true)

           });
    }

    const loademore =() =>{
        setIsMoreLoading(true)
        getBooksList()
    } 
    const trancateTitle= (title)=> {
      try{
          var length = 20;
          if (title.length > length) {
             title = title.substring(0, length)+'...';
          }
          return title;
      }catch{
          return title;

      }
      
  }
  const goToDeacriton = (item) => {
   
    history.push({pathname:'/book/isbn/'+ item.eisbn,state:{contentid:item.contentId,fuzzyid:item.fuzzyId}})

     
    
    }

  if (isOnLine == "offline") {
    return (
      <div className="continer">
        <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

          {/* <Header titel={name} org={org}/> */}
          <PageHader titel={category} />

          <Offline mtop="1opx" />
        </Col>
      </div>
    )

  }
  if (error) {
    return (
      <div className="continer">
        <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

          {/* <Header titel={name} org={org}/> */}
          <PageHader titel={category} />

          <Error500 mtop="1opx" />
        </Col>
      </div>
    )

  }
   
   
  
  if (isLoading) {
    return (
      <div className="continer">
        <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>

          {/* <Header titel={name} org={org}/> */}
          <PageHader titel={category} />

          <Row className="listcontiner">
            <Skeletonbook />
          </Row>
        </Col>
      </div>
    );
  }
   
        return (
          <div className="continer">
          <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>
    
            {/* <Header titel={name} org={org} /> */}
            <PageHader titel={category} />
            {books.length > 0 ? 
            <div className="cards-container listcontiner">
              {books.map((item) => {
                return (
                  <div className="ion-card" onClick={() => { goToDeacriton(item) }} >
                    <div className="bookcover_continer" >
                      <Image className="bookcover"
                      preview={false}
                        fallback="data:image/png;base64,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"
                        src={bookcover + item.fuzzyId + "/" + item.cover} />
                    </div>
                    <div className="bookcontent">
    
                      <div >
                        <div className="booktitle" >{item.name}</div>
                        <div className='card-sub'>{item.subTitle}</div>
                        <div className='card-auth'>{item.authors.map(item => item.surName + " " + item.givenName).toString().replaceAll(",", ", ")}</div>
                      </div>
    
    
    
    
                    </div>
                  </div>
    
                )
              })}
              <Space hig="10px" color="#ffffff" />
    
            </div> :
              <div className="nodata">
                <img src={listbook} width={"100px"} />
                No book found under the {category}  category,Sorry!
              </div>
            }
          </Col>
        </div>
        );
    }


export default Booksbycategory;